<ng-container *ngIf="!task; else InsideBaseTask">
  <!-- acceso sin tarea , se anyade la misma estructura de baseTask.template-->
  <ng-container *ngIf="isModalWindow; else outsideTask">
    <sub-header [isModal]="true" [windowHash]="windowHash"></sub-header>
    <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
      <ng-container *ngTemplateOutlet="InsideBaseTask"></ng-container>
    </p-scrollPanel>
  </ng-container>
</ng-container>
<ng-template #outsideTask>
  <div class="col-12 p-0">
    <ng-container *ngTemplateOutlet="InsideBaseTask"></ng-container>
  </div>
</ng-template>
<ng-template #InsideBaseTask>
  <div class="container-fluid ">
    <div class="row" *ngIf="formConfig">
      <!-- contenido-->
      <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig" class="col-12"></formPlyca>
    </div>
  </div>
</ng-template>
<ng-template #fromTemplate let-formPlycaGroup="formPlycaGroup">
  <communication-field-from [model]="model" [formPlycaGroup]="formPlycaGroup"
    (editDialogOpened)="setEditDialogOpened($event)"></communication-field-from>
</ng-template>
<ng-template #toTemplate let-formPlycaGroup="formPlycaGroup">
  <communication-field-to [model]="model" [formPlycaGroup]="formPlycaGroup"
    (editDialogOpened)="setEditDialogOpened($event)">
  </communication-field-to>
</ng-template>
<ng-template #docsTemplate let-formPlycaGroup="formPlycaGroup">
  <communication-field-docs [model]="model" [formPlycaGroup]="formPlycaGroup"
    (editDialogOpened)="setEditDialogOpened($event)"></communication-field-docs>
</ng-template>